import React, { Component } from "react";
import { Text, View, TouchableOpacity, StyleSheet } from "react-native";

class DocRequestList extends Component {
  state = {
    names: [
      {
        id: 0,
        name: "Security",
        category: "Security",
        criteria_control: "COSO Principle 1",
        control_description: "The Company has a formalized Code of Conduct, which demonstrate the importance of integrity and ethical values. The Code of Conduct is included in the Employee Handbook, which is available to employees via the intranet.",
        requested_evidence: "1. Provide the Code of Conduct / Employee Handbook. 2. Provide a screenshot of where this is available to employees.",
        evidence_needed: "yes",
        observation_required: "yes",
        client_upload_status: "Evidence Upload - Completed",
        evidence_owner: "Justin Davidson",
        evidence_result: "No exceptions noted",
        linked_controls: "",
        evidence_comments: "",
      },
      {
        id: 1,
        name: "Availability",
      },
      {
        id: 2,
        name: "Process Integrity",
      },
      {
        id: 3,
        name: "Confidentiality",
      },
      {
        id: 4,
        name: "Privacy",
      },
    ],
  };
  alertItemName = (item) => {
    alert(item.name);
  };
  render() {
    return (
      <View>
        {this.state.names.map((item, index) => (
          <TouchableOpacity
            key={item.id}
            style={styles.container}
            onPress={() => this.alertItemName(item)}
          >
            <Text style={styles.text}>{item.name} {item.category} {item.criteria_control} {item.control_description} {item.requested_evidence} {item.evidence_needed} {item.observation_required} {item.client_upload_status} {item.evidence_owner} {item.evidence_result} {item.linked_controls} {item.evidence_comments}</Text>
          </TouchableOpacity>
        ))}
      </View>
    );
  }
}
export default DocRequestList;

const styles = StyleSheet.create({
  container: {
    padding: 10,
    marginTop: 3,
    backgroundColor: "white",
    alignItems: "center",
  },
  text: {
    color: "#4f603c",
  },
});
